import { useEffect, useState } from "react";
import { ComponentProps } from "@arelia-types/widget";
import PlanBreakdownPresenter from "./PlanBreakdownPresenter";
import { useHqCustomersAPI } from "src/features/hq/customers/hq-customers.api";
import { SubscriptionPlanName } from "@arelia-types/subscriptions";

type PlanBreakdownData = {
  Premium: { paid: number; free: number };
  PremiumMyFans: { paid: number; free: number };
  Starter: number;
};

export default function PlanBreakdownContainer({ config }: ComponentProps) {
  const [planBreakdown, setPlanBreakdown] = useState<PlanBreakdownData>({
    Premium: { paid: 0, free: 0 },
    PremiumMyFans: { paid: 0, free: 0 },
    Starter: 0,
  });

  const { data: customers, isFetching } = useHqCustomersAPI();

  useEffect(() => {
    if (!customers) return;

    const next: PlanBreakdownData = {
      Premium: { paid: 0, free: 0 },
      PremiumMyFans: { paid: 0, free: 0 },
      Starter: 0,
    };

    for (const c of customers) {
      const sub = c?.subscription;
      if (!sub?.plan) continue;

      const isFree = Boolean(sub.isFreePlan);

      switch (sub.plan as SubscriptionPlanName) {
        case SubscriptionPlanName.Premium:
          next.Premium[isFree ? "free" : "paid"] += 1;
          break;

        case SubscriptionPlanName.PremiumMyFans:
          next.PremiumMyFans[isFree ? "free" : "paid"] += 1;
          break;

        case SubscriptionPlanName.Starter:
          next.Starter += 1;
          break;

        case SubscriptionPlanName.Free:
          break;

        default:
          break;
      }
    }

    setPlanBreakdown(next);
  }, [customers]);

  return (
    <PlanBreakdownPresenter
      data={planBreakdown}
      loading={isFetching}
      widgetConfig={config}
    />
  );
}
